@if (!drawingFile) {
  <div class="flex flex-col p-2 pr-4">
    <p class="text-sm text-muted-color">
      No drawing extraction data available.
    </p>
  </div>
} @else {
  <div class="flex flex-col p-2 pr-4 pb-20">
    @if (hasReviewNotes) {
      <div
        class="mb-4 flex flex-col gap-4 rounded-lg border border-surface-switch-200 bg-surface-switch-50 p-4"
      >
        @if (drawingOverview) {
          <div class="min-w-0 flex flex-col gap-3">
            <div class="flex items-center gap-2 text-sm font-medium">
              <i class="pi pi-sparkles text-primary" aria-hidden="true"></i>
              Part overview
            </div>
            <p class="m-0 text-sm leading-relaxed">
              {{ drawingOverview }}
            </p>
          </div>
        }
        @if (suggestionAdvice.length) {
          <div class="min-w-0 flex flex-col gap-2">
            <div class="text-sm font-medium">
              Issues and advice · {{ suggestionAdvice.length }}
            </div>
            @for (adviceItem of suggestionAdvice; track $index) {
              <div
                class="flex items-start gap-2 rounded-md px-3 py-2 text-sm text-surface-switch-900"
                [class.bg-orange-400/15]="adviceItem.type === 'warning'"
                [class.bg-sky-400/15]="adviceItem.type === 'advice'"
              >
                <i
                  [class]="
                    'mt-0.5 shrink-0 pi ' +
                    (adviceItem.type === 'warning'
                      ? 'pi-exclamation-triangle text-orange-400'
                      : 'pi-info-circle text-sky-400')
                  "
                  aria-hidden="true"
                ></i>
                <span>{{ adviceItem.text }}</span>
              </div>
            }
          </div>
        }
      </div>
    }
    @for (field of fields; track field.label) {
      <div
        class="grid grid-cols-2 gap-4 py-2.5 border-b border-surface-switch-100"
        [class.items-center]="!field.multiline"
        [class.items-start]="field.multiline"
      >
        <span
          class="text-sm text-surface-switch-600"
          [class.pt-2]="field.multiline"
          >{{ field.label }}</span
        >
        <span
          class="text-sm font-medium text-right"
          [class.whitespace-pre-wrap]="field.multiline"
          >{{ field.value }}</span
        >
      </div>
    }
  </div>
}
